import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { AppContext, SeoService } from '../../shared';
import { BlogPage } from  '../blog-page';

@Component({
  selector: 'logit-one-chooses-linescape-as-sailling-schedule-provider',
  template: require('./logit-one-chooses-linescape-as-sailling-schedule-provider.html'),
  styles: [require('./../blog.component.scss'), require('./logit-one-chooses-linescape-as-sailling-schedule-provider.scss')]
})
export class LogitOneChoosesLinescapeAsSaillingScheduleProvider extends BlogPage {
  title = "Logit One chooses Linescape as Sailing Schedule Provider";
  description = "Linescape  was chosen by Logit One, Belgium, to provide consolidated sailing schedules to the Logit One platform for collaborative transport coordination, intermediation and visibility.";

  constructor(route: ActivatedRoute, app: AppContext, seo: SeoService) {
    super(route, app, seo);
  }
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/press/logit-one-chooses-linescape-as-sailling-schedule-provider/logit-one-chooses-linescape-as-sailling-schedule-provider.ts